export const HOT_STORIES_DEFAULT_BUTTON_TITLE = "לכתבה המלאה"
export const HOT_STORIES_MIN_ITEMS = 3
export const HOT_STORIES_BG = "#0c1c3a"
export const HOT_STORIES_ACCENT = "#de1a1a"
export const HOT_STORIES_DEFAULT_TAB_TITLE = "הסיפורים החמים"
export const HOT_STORIES_DEFAULT_MORE_TITLE = "כתבות נוספות"
